<div class="wizard-container btn-bar-wrapper" test-id="test-wizard">
  <ng-container *ngIf="isMobileDevice; else biggerScreen">
    <div class="navigation-top">
      <button (click)="previous()"
              *ngIf="displayButtons"
              [disabled]="disablePrevious()"
              class="btn btn-plain-default"
              test-id="backButton"
              type="button">
        <i aria-hidden="true" class="fa fa-light fa-angle-left"></i>
        {{(previousButtonLabel ? previousButtonLabel : 'EMPLOYEE_HIRE.back') | translate}}
      </button>
      <div class="step-name">
        <strong>{{ currentStep.number + 1 }}/{{steps.length}}</strong>&nbsp;{{ currentStep.name }}
      </div>
    </div>
    <div class="navigation-bottom">
      <button (click)="next()"
              [disabled]="disableNext || !currentStepValid || (isLastStep && readOnly)"
              *ngIf="displayButtons"
              class="btn next-button"
              [ngClass]="isLastStep ? 'btn-fill-primary' : 'btn-fill-default'"
              test-id="nextButton"
              type="submit">
        {{ isLastStep ? submitButtonLabel : ('EMPLOYEE_HIRE.next' | translate) }}
      </button>
    </div>
  </ng-container>
  <ng-template #biggerScreen>
    <div *ngIf="displayButtons" class="btn-bar navigation-buttons p-r-sm">
      <button (click)="previous()"
              [disabled]="disablePrevious()"
              class="btn btn-md btn-block back-button btn-plain-default"
              test-id="backButton"
              type="button">
        {{(previousButtonLabel ? previousButtonLabel : 'EMPLOYEE_HIRE.back') | translate}}
      </button>
      <button *ngIf="additionalLastActionButton && isLastStep" (click)="onAdditionalActionClick()"
              [disabled]="disableNext || !currentStepValid || readOnly"
              class="btn btn-md btn-block btn-outline-primary"
              test-id="additionalActionButton"
              type="submit">
        {{ additionalLastActionButton }}
      </button>
      <button (click)="next()"
              [disabled]="disableNext || !currentStepValid || (isLastStep && readOnly)"
              class="btn btn-md btn-block next-button"
              [ngClass]="isLastStep ? 'btn-fill-primary' : 'btn-fill-default'"
              test-id="nextButton"
              type="submit">
        {{ isLastStep ? submitButtonLabel : ('EMPLOYEE_HIRE.next' | translate) }}
      </button>
    </div>
    <ul class="wizard">
      <li *ngFor="let step of steps;" [ngClass]="{
            'is-error': step.completed && !step.valid,
            'is-completed': (step.completed || !displayButtons) && step.valid,
            'is-active': step.active && !(step.completed && !step.valid),
            'is-disabled': step.disabled,
            'is-upcoming': displayButtons && !step.active && !step.completed && !step.disabled
          }"
          class="step">
        <span class="step-circle">
          <i *ngIf="step.completed && !step.valid"
             class="fa fa-solid fa-exclamation"
             aria-hidden="true"></i>
          <span *ngIf="!(step.completed && !step.valid)" class="step-number">
            {{ step.number + 1 }}
          </span>
        </span>
        <span class="step-name">{{ step.name }}</span>
      </li>
    </ul>
  </ng-template>
</div>
<ng-content></ng-content>
